module.exports = __webpack_public_path__ + "img/img30.db66b817.svg";